import { supabase } from '@/lib/supabase';

export const ugcBrandsService = {
  async list() {
    const { data, error } = await supabase
      .from('ugc_brands')
      .select('*')
      .order('is_seed', { ascending: false })
      .order('name', { ascending: true });
    if (error) throw error;
    return data || [];
  },

  async create(userId, payload) {
    const tags = Array.isArray(payload.tags) ? payload.tags : [];
    const { data, error } = await supabase
      .from('ugc_brands')
      .insert({
        name: payload.name,
        category: payload.category,
        website: payload.website || null,
        email: payload.email || null,
        notes: payload.notes || null,
        tags,
        created_by: userId
      })
      .select()
      .single();
    if (error) throw error;
    return data;
  },

  async update(id, payload) {
    const tags = Array.isArray(payload.tags) ? payload.tags : [];
    const { data, error } = await supabase
      .from('ugc_brands')
      .update({
        name: payload.name,
        category: payload.category,
        website: payload.website || null,
        email: payload.email || null,
        notes: payload.notes || null,
        tags
      })
      .eq('id', id)
      .select()
      .single();
    if (error) throw error;
    return data;
  },

  async remove(id) {
    const { error } = await supabase
      .from('ugc_brands')
      .delete()
      .eq('id', id);
    if (error) throw error;
    return true;
  }
};
